'use client'
import React, { FunctionComponent } from 'react'
import { parseContent } from '@utils/content-parser'
import { useTheme } from 'next-themes'
import { motion } from 'framer-motion'

type Props = {
  aboutMe: string
}

const IntroSection: FunctionComponent<Props> = ({ aboutMe }) => {
  const { theme } = useTheme()
  const imgSrc =
    theme === 'light'
      ? '/day-animated-developer.gif'
      : '/night-animated-developer.gif'

  return (
    <section className="py-4">
      <div className="grid grid-cols-12 gap-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="col-span-12 flex flex-col items-center"
        >
          <div className="bg-white/50 dark:bg-black/20 backdrop-blur-sm rounded-[2rem] p-8 md:p-12 shadow-sm border border-black/5 dark:border-white/5 max-w-[72rem]">
            <h3 className="text-4xl md:text-5xl font-bold mb-8 font-lexend text-[var(--foreground)] border-l-4 border-[#f90] pl-6">
              About Me
            </h3>
            <div className="grid grid-cols-12 gap-8 items-center">
              <div className="md:col-span-5 col-span-12 order-2 md:order-1">
                <div className="relative rounded-2xl overflow-hidden shadow-lg transform rotate-[-2deg] hover:rotate-0 transition-transform duration-300">
                  <img
                    src={imgSrc}
                    alt={
                      theme === 'light'
                        ? 'Animated developer at day'
                        : 'Animated developer at night'
                    }
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="md:col-span-7 col-span-12 order-1 md:order-2">
                <div className="prose dark:prose-invert prose-lg max-w-none text-[var(--foreground)]/90 leading-relaxed font-light">
                  {parseContent(aboutMe)}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default IntroSection
